import { useState } from "react";

import { Post } from "../../types/types";

export const useFullScreenPost = () => {
  const [isFullScreenPostOpened, setIsFullScreenPostOpened] = useState(false);
  const [fullScreenPost, setFullScreenPost] = useState<Post | null>(null);

  const openFullScreenPost = (post: Post) => {
    setFullScreenPost(post);
    setIsFullScreenPostOpened(true);
  };

  const closeFullScreenPost = () => {
    setIsFullScreenPostOpened(false);
    setFullScreenPost(null);
  };

  return {
    isFullScreenPostOpened,
    fullScreenPost,
    openFullScreenPost,
    closeFullScreenPost,
  };
};
